"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var ContentSubscriptionLevelSubjectTypeEnum;
(function (ContentSubscriptionLevelSubjectTypeEnum) {
    ContentSubscriptionLevelSubjectTypeEnum["CONTENT_SET"] = "content_set";
})(ContentSubscriptionLevelSubjectTypeEnum = exports.ContentSubscriptionLevelSubjectTypeEnum || (exports.ContentSubscriptionLevelSubjectTypeEnum = {}));
class ContentSubscriptionLevelProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ContentSubscriptionLevel: () => `
        ... on ContentSubscriptionLevel {
          subject {
            ${this.getFragment("Subject")}
          }
          levelId
          onlyFollowers
        }`,
        };
    }
    search({ subjects }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("contentSubscriptionLevelsFind", { subjects }, this.getFragment("ContentSubscriptionLevel"));
        });
    }
    getStats({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("contentSubscriptionLevelStats", { data }, this.getFragment("ContentSubscriptionLevel"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("contentSubscriptionLevelUpdate", { data }, this.getFragment("ContentSubscriptionLevel"));
        });
    }
}
exports.ContentSubscriptionLevelProvider = ContentSubscriptionLevelProvider;
//# sourceMappingURL=ContentSubscriptionLevelProvider.js.map